export enum TagIntent {
  Primary = "primary",
  Secondary = "secondary",
  Outlined = "outlined",
  Success = "success",
  Warning = "warning",
  Danger = "danger",
}
